import React from "react";
import {Button, inputStyles} from "../Inputs/";
import {GridCell, gridConstants, GridContainer} from "./";

interface ResultsPagerProps {
    currentPage?: number;
    disabled?: boolean;
    handleFirstClick: () => void;
    handlePreviousClick: () => void;
    handleNextClick: () => void;
    handleLastClick: () => void;
    isSecondaryPager?: boolean;
    recordsPerPage?: number;
    totalRecords?: number;
}

export const ResultsPager: React.FC<ResultsPagerProps> = ({
    currentPage,
    disabled,
    handleFirstClick,
    handlePreviousClick,
    handleNextClick,
    handleLastClick,
    isSecondaryPager,
    recordsPerPage,
    totalRecords,
}) => {
    const hideSecondaryPager = isSecondaryPager && totalRecords! < recordsPerPage!;
    if (!totalRecords || hideSecondaryPager) return null;

    let activePage = currentPage!;
    if( totalRecords <= recordsPerPage!) {
        activePage = 1;
    }

    let firstVisibleRecord = (activePage - 1) * recordsPerPage! + 1;

    let recordsOnCurrentPage = activePage * recordsPerPage!;
    let lastVisibleRecord =
        totalRecords > recordsOnCurrentPage ? (activePage - 1) * recordsPerPage! + recordsPerPage! : totalRecords;

    let cantNavigateBackward = activePage === 1;
    let cantNavigateForward = lastVisibleRecord >= totalRecords;

    return (
        <>
            {
                cantNavigateBackward && cantNavigateForward &&
                <div>
                    <div className={`pager__text`}>
                        {`Displaying ${totalRecords} Records`}
                    </div>
                </div>
            }
            {
                (!cantNavigateBackward || !cantNavigateForward) &&
                <nav aria-label="Search Results">
                    <GridContainer hasMarginX className={`pager`}>
                        <GridCell small_columns={gridConstants.column.TWO}>
                            <Button
                                onClick={handleFirstClick}
                                buttonType={inputStyles.button.types.FIRST}
                                name="btnFirstPage"
                                label="First"
                                showLabel={false}
                                disabled={disabled || cantNavigateBackward}
                            />
                        </GridCell>
                        <GridCell small_columns={gridConstants.column.THREE}>
                            <Button
                                onClick={handlePreviousClick}
                                buttonType={inputStyles.button.types.PREVIOUS}
                                name="btnPreviousPage"
                                label="Previous"
                                showLabel={false}
                                disabled={disabled || cantNavigateBackward}
                            />
                        </GridCell>
                        <GridCell small_columns={gridConstants.column.TWO}>
                            <div className={`pager__text`}>
                                <span className={`show-for-sr`}> Displaying Records </span>
                                <span>{`${firstVisibleRecord} – ${lastVisibleRecord} of ${totalRecords}`}</span>
                                <span className={`show-for-sr`}> Total Records </span>
                            </div>
                        </GridCell>

                        <GridCell small_columns={gridConstants.column.THREE}>
                            <Button
                                onClick={handleNextClick}
                                buttonType={inputStyles.button.types.NEXT}
                                name="btnNextPage"
                                label="Next"
                                showLabel={false}
                                disabled={disabled || cantNavigateForward}
                            />
                        </GridCell>
                        <GridCell small_columns={gridConstants.column.TWO}>
                            <Button
                                onClick={handleLastClick}
                                buttonType={inputStyles.button.types.LAST}
                                name="btnLastPage"
                                label="Last"
                                showLabel={false}
                                disabled={disabled || cantNavigateForward}
                            />
                        </GridCell>
                    </GridContainer>
                </nav>
            }
        </>
    );
};
